import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  Breadcrumbs,
  Flex,
  FlexColumn,
  Tab,
  Tabs,
} from '@elementary/common-ui/components';
import useAccountPermission from '@elementary/common-ui/hooks/useAccountPermission';
import AiUsage from '../AiUsage/AiUsage';
import AiByokSection from './AiByokSection';
import AiMcpSection from './AiMcpSection';

export type AiSettingsTab = 'usage' | 'mcp' | 'byok';

const TAB_PARAM = 'tab';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: 24px;
`;

const TabsStyled = styled(Tabs)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.common.gray8};
`;

const AiSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasAccountPermission = useAccountPermission();
  const canViewIntegrations = hasAccountPermission('VIEW_INTEGRATIONS');

  const requestedTab = searchParams.get(TAB_PARAM);
  const selectedTab: AiSettingsTab =
    (requestedTab === 'mcp' || requestedTab === 'byok') && canViewIntegrations
      ? requestedTab
      : 'usage';

  const onTabChange = (tab: AiSettingsTab) => {
    const next = new URLSearchParams(searchParams);
    next.set(TAB_PARAM, tab);
    setSearchParams(next, { replace: true });
  };

  return (
    <Wrapper>
      <Breadcrumbs
        items={['Account', 'Agent Settings']}
        showTreeButton={false}
      />
      <Flex>
        <TabsStyled
          value={selectedTab}
          onChange={(_, val) => onTabChange(val as AiSettingsTab)}
          orientation="horizontal"
        >
          <Tab label="Usage" value="usage" $size="small" />
          {canViewIntegrations && (
            <Tab label="MCP Connections" value="mcp" $size="small" />
          )}
          {canViewIntegrations && (
            <Tab label="BYOK" value="byok" $size="small" />
          )}
        </TabsStyled>
      </Flex>
      {selectedTab === 'usage' && <AiUsage />}
      {selectedTab === 'mcp' && <AiMcpSection />}
      {selectedTab === 'byok' && <AiByokSection />}
    </Wrapper>
  );
};

export default AiSettings;
